export default import.meta.ROLLDOWN_FILE_URL_sgevQHA$9rrkn3nu49HsPg